import React from 'react';
import Anchor from '@sdtech/sd-ui/Anchor';

export default function UrlFormatError() {
  return (
    <div>
      Sorry, your request could not be processed because the format of the URL was incorrect.
      Contact the
      {' '}
      <Anchor href="https://service.elsevier.com/app/contact/supporthub/sciencedirect/" className="u-clr-orange">
        support team
      </Anchor>
      &nbsp;if the problem persists.
    </div>
  );
}
